import ProfileWrap from "./profile-wrap";

export default ProfileWrap;